<h1 matDialogTitle>Add External Line</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%;margin-top: 16px">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>External Code</mat-label>
        <input matInput type="text" #nonStockCode formControlName="nonStockCode" maxlength="30"
          autocomplete="new-password">
        <mat-hint align="end">{{nonStockCode.value.length}} / 30</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Unit RSP Incl. VAT</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="unitRspIncVat" autocomplete="new-password">
      </mat-form-field>

      <!-- <mat-form-field fxFlex="100" width="100%">
        <mat-label>External Description</mat-label>
        <input matInput type="text" #nonStockDesc formControlName="nonStockDesc" maxlength="50"
          autocomplete="new-password">
        <mat-hint align="end">{{nonStockDesc.value.length}} / 50</mat-hint>
      </mat-form-field> -->

    </div>
  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [matDialogClose]="undefined">Cancel</button>
  <button [disabled]="!form.valid" mat-button (click)="save()">Save</button>
</mat-dialog-actions>
